export default "__VITE_ASSET__28ddb6cd__"